const userSettings = {
  subheadings: {
    personal_information: 'Personal Information',
    tenant_select: 'Active Division',
    signature: 'Digital Signature',
  },
  helpers: {
    tenant_select: 'Select the division you want to use for this user',
    no_email:
      'Some external systems may require a validated email address and password',
  },
  labels: {
    notifications: 'Notification Preferences',
    reset_password: 'Reset Password',
    resend_registration: 'Resend Registration Email',
    text: 'Text',
    email: 'Email',
    noEmail: '(unregistered email)',
    resend_registration_external: 'Send Registration Link',
  },
  signature: {
    title: 'Property Manager Signature Required',
    apply: 'Apply Signature',
    create_new: 'Create New',
    saveReminder:
      'Your new signature will not be saved until you press the Update Settings button',
    placeholder: 'Click the edit button to unlock the signature pad',
    placeholder_editing: 'Hold down the left mouse button to draw and sign',
    saved: 'Signature saved successfully',
    error: 'Failed to save signature',
  },
};

export default userSettings;
